<div>
    <mat-card>
        <mat-card-header>
            <mat-card-subtitle>
                <h1>PSE-AV</h1>
            </mat-card-subtitle>
        </mat-card-header>
        <hr>
        <mat-card-content>
            <div class="grid cols-1">
                <img src="{{info.logo}}" class="payment_method_no_interactive __method_brands" alt="Logo PSE AV">
            </div>
        </mat-card-content>
        <hr>
        <form #form action='https://www.pagosvirtualesavvillas.com.co/personal/pagos/pagar' method='post'>
            <input type='hidden' name='convenioId' value='{{pseavTransaction.convenioId}}'>
            <input type='hidden' name='transaccionConvenioId' value='{{pseavTransaction.transaccionConvenioId}}'>
            <input type='hidden' name='referenciaPago1' value='{{pseavTransaction.referenciaPago1}}'>

            <input type='hidden' name='descripcion' value='{{pseavTransaction.descripcion}}'>
            <input type='hidden' name='valor' value='{{pseavTransaction.valor}}'>
            <input type='hidden' name='urlRespuesta' value='{{pseavTransaction.urlRespuesta}}'>
            <input type='hidden' name='hash' value='{{pseavTransaction.hash}}'>

        </form>

        <mat-card-content>
            <mat-card-header>
                <mat-card-subtitle>
                    <h1>Debes saber</h1>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                El pago se realizará a través de Pagos Seguros en linea PSE del banco AV VILLAS, que debitará los
                recursos en línea de la entidad financiera que selecciones.
            </mat-card-content>
            <hr>
            <mat-card-content>
                    <p>Si tienes alguna duda sobre tu pago, comunícate con:</p>
                    <p *ngIf="transaction.MERCHANT_TEL != '' && transaction.MERCHANT_TEL != null"><strong>Teléfono:</strong>{{transaction.MERCHANT_TEL}}</p>
                    <p *ngIf="transaction.MERCHANT_CEL != '' && transaction.MERCHANT_CEL != null"><strong>Celular:</strong>{{transaction.MERCHANT_CEL}}</p>
                    <p *ngIf="transaction.MERCHANT_EMAIL != '' && transaction.MERCHANT_EMAIL != null"><strong>Email:</strong> {{transaction.MERCHANT_EMAIL}} </p>
            </mat-card-content>
        </mat-card-content>
        <div>
            <app-buttons-bar [template]="template" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()" (PAY)="validData(form)"></app-buttons-bar>
        </div>
    </mat-card>
</div>
